var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'sp-price',
    {
      'line-through': _vm.lineThrough
    }
  ]},[_c('span',{staticClass:"symbol",style:({ 'font-size': `${_vm.size}px` })},[_vm._v(_vm._s(_vm.symbol))]),_c('span',{staticClass:"int-value",style:({ 'font-size': `${_vm.size}px` })},[_vm._v(_vm._s(_vm.intValue))]),_c('span',{staticClass:"decimal-value",style:({ 'font-size': `${_vm.size - 2}px` })},[_vm._v(_vm._s(`.${_vm.decimalValue}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }